import { render } from "./Form.vue?vue&type=template&id=0c292f58"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
script.render = render

export default script